import React from 'react';
import { Switch } from 'react-router-dom';

import Route from './Route';

import SignIn from '../pages/SignIn';
import ForgotPassword from '../pages/ForgotPassword';
import Contact from '../pages/NewContact';
import ContactSuccess from '../pages/ContactSuccess';
import Dashboard from '../pages/Dashboard';
import DashboardDetails from '../pages/DashboardDetails';
import CustomerIntelligence from '../pages/CustomerIntelligence';
import Configuracoes from '../pages/Configuracoes';

import ProdutoAcabado from '../pages/Produtos/ProdutoAcabado';
import Historico from '../pages/Historico';
import Schedules from '../pages/Schedules';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import DiscountCoupon from '../pages/DiscountCoupon';
import CreateDiscountCoupon from '../pages/CreateDiscountCoupon';
import EditDiscountCoupon from '../pages/EditDiscountCoupon';
import FreeDelivery from '../pages/FreeDelivery';
import CreateFreeDelivery from '../pages/CreateFreeDelivery';
import EditFreeDelivery from '../pages/EditFreeDelivery';
import FirstPurchase from '../pages/FirstPurchase';
import CreateFirstPurchase from '../pages/CreateFirstPurchase';
import EditFirstPurchase from '../pages/EditFirstPurchase';

// New pages

import Products from '../newPages/Products';
import OrderMonitor from '../newPages/OrderMonitor';
import CreateFuncionarioV2 from '../newPages/Funcionarios/CreateFuncionario';
import EditFuncionarioV2 from '../newPages/Funcionarios/EditFuncionario';
import RawMaterial from '../newPages/RawMaterial';
import NewOrder from '../newPages/NewOrder';
import EditOrder from '../newPages/EditOrder';
import { Tags } from '../pages/Tags';
import RestrictedAreas from '../newPages/RestrictedAreas';

import GruposTributarios from '../newPages/GruposTributarios';
import CreateGrupoTributario from '../newPages/GruposTributarios/CreateGrupoTributario';
import EditGrupoTributario from '../newPages/GruposTributarios/EditGrupoTributario';
import RegrasIbsCbsIs from '../newPages/RegrasIbsCbsIs';
import EditRegraIbsCbsIs from '../newPages/RegrasIbsCbsIs/EditRegraIbsCbsIs';
import CategoriasFiscais from '../newPages/CategoriasFiscais';
import CreateCategoriaFiscal from '../newPages/CategoriasFiscais/CreateCategoriaFiscal';
import EditCategoriaFiscal from '../newPages/CategoriasFiscais/EditCategoriaFiscal';
import TerminaisFiscais from '../newPages/TerminaisFiscais';
import CreateTerminalFiscal from '../newPages/TerminaisFiscais/CreateTerminalFiscal';
import EditTerminalFiscal from '../newPages/TerminaisFiscais/EditTerminalFiscal';
import AtivarEmissao from '../newPages/AtivarEmissao';
import SaudeFiscal from '../newPages/SaudeFiscal';
import NotasEmitidas from '../newPages/NotasEmitidas';
import Inutilizacao from '../newPages/Inutilizacao';
import HistoricoContador from '../newPages/HistoricoContador';

const Routes: React.FC = () => {
  return (
    <Switch>
      <Route path="/" exact component={SignIn} />
      <Route path="/forgot" exact component={ForgotPassword} />
      <Route path="/contact" component={Contact} />
      <Route path="/products" exact isPrivate component={Products} />
      <Route path="/contact-success" exact component={ContactSuccess} />

      <Route path="/dashboard" exact component={Dashboard} isPrivate />
      <Route
        path="/inteligencia-comercial"
        exact
        component={CustomerIntelligence}
        isPrivate
      />
      <Route
        path="/areas-restritas"
        exact
        component={RestrictedAreas}
        isPrivate
      />
      <Route
        path="/dashboard/details"
        exact
        component={DashboardDetails}
        isPrivate
      />
      {/* Rota específica ANTES da paramétrica /configuracoes/:tab — senão o
          :tab casa "ativar-emissao" e renderiza Configurações em vez do wizard. */}
      <Route
        path="/configuracoes/ativar-emissao"
        exact
        component={AtivarEmissao}
        isPrivate
      />
      <Route
        path="/configuracoes/:tab"
        component={Configuracoes}
        isPrivate
        exact
      />
      <Route
        path="/configuracoes/:tab/:subTab"
        component={Configuracoes}
        exact
        isPrivate
      />
      <Route
        path="/funcionario/new"
        component={CreateFuncionarioV2}
        isPrivate
      />
      <Route
        path="/funcionario/edit/:id"
        component={EditFuncionarioV2}
        isPrivate
      />

      <Route
        path="/grupos-tributarios"
        exact
        component={GruposTributarios}
        isPrivate
      />
      <Route
        path="/grupos-tributarios/new"
        exact
        component={CreateGrupoTributario}
        isPrivate
      />
      <Route
        path="/grupos-tributarios/edit/:id"
        exact
        component={EditGrupoTributario}
        isPrivate
      />
      <Route
        path="/regras-ibs-cbs-is"
        exact
        component={RegrasIbsCbsIs}
        isPrivate
      />
      <Route
        path="/regras-ibs-cbs-is/edit/:id"
        exact
        component={EditRegraIbsCbsIs}
        isPrivate
      />
      <Route
        path="/categorias-fiscais"
        exact
        component={CategoriasFiscais}
        isPrivate
      />
      <Route
        path="/categorias-fiscais/new"
        exact
        component={CreateCategoriaFiscal}
        isPrivate
      />
      <Route
        path="/categorias-fiscais/edit/:id"
        exact
        component={EditCategoriaFiscal}
        isPrivate
      />
      <Route
        path="/terminais-fiscais"
        exact
        component={TerminaisFiscais}
        isPrivate
      />
      <Route
        path="/terminais-fiscais/new"
        exact
        component={CreateTerminalFiscal}
        isPrivate
      />
      <Route
        path="/terminais-fiscais/edit/:id"
        exact
        component={EditTerminalFiscal}
        isPrivate
      />
      <Route path="/saude-fiscal" exact component={SaudeFiscal} isPrivate />
      <Route path="/schedules" component={Schedules} isPrivate />
      <Route
        path="/cupom-desconto"
        exact
        component={DiscountCoupon}
        isPrivate
      />
      <Route
        path="/cupom-desconto/criar"
        exact
        component={CreateDiscountCoupon}
        isPrivate
      />
      <Route
        path="/cupom-desconto/editar/:id"
        exact
        component={EditDiscountCoupon}
        isPrivate
      />
      <Route path="/frete-gratis" exact component={FreeDelivery} isPrivate />
      <Route
        path="/frete-gratis/criar"
        exact
        component={CreateFreeDelivery}
        isPrivate
      />
      <Route
        path="/frete-gratis/editar/:id"
        exact
        component={EditFreeDelivery}
        isPrivate
      />
      <Route
        path="/primeira-compra"
        exact
        component={FirstPurchase}
        isPrivate
      />
      <Route
        path="/primeira-compra/criar"
        exact
        component={CreateFirstPurchase}
        isPrivate
      />
      <Route
        path="/primeira-compra/editar/:id"
        exact
        component={EditFirstPurchase}
        isPrivate
      />
      <Route
        path="/produtos/produto_acabado"
        component={ProdutoAcabado}
        isPrivate
      />
      <Route path="/produtos/materia_prima" component={RawMaterial} isPrivate />

      <Route path="/monitor_pedidos" exact component={OrderMonitor} isPrivate />
      <Route
        path="/monitor_pedidos/edit/:orderId"
        exact
        component={EditOrder}
        isPrivate
      />
      <Route path="/monitor_pedidos/new" component={NewOrder} isPrivate />

      <Route path="/historico" component={Historico} isPrivate />

      <Route path="/notas-emitidas" exact component={NotasEmitidas} isPrivate />
      <Route path="/inutilizacao" exact component={Inutilizacao} isPrivate />
      <Route
        path="/historico-contador"
        exact
        component={HistoricoContador}
        isPrivate
      />

      <Route path="/etiquetas" component={Tags} isPrivate exact />
      <Route path="/etiquetas/:orderId" component={Tags} isPrivate exact />

      <Route path="/privacy-policy" component={PrivacyPolicy} isPrivate />
    </Switch>
  );
};

export default Routes;
